import { render, staticRenderFns } from "./LayoutPage.vue?vue&type=template&id=69c4cf08&"
import script from "./LayoutPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./LayoutPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports